import isEmpty from 'lodash/isEmpty';
import {
  railsClientNewLogging,
  context,
  device,
  user
} from './PdtModel/RailsPdtTemplate';
import {ProfileType} from '@mmt/legacy-commons/Native/UserSession/UserSessionModule';
import {now} from '@mmt/legacy-commons/Helpers/dateHelpers';

export default class BaseGenericEvent {
  constructor(pdtData) {
    const {
      userDetails,
      deviceDetails,
      activityName,
      pageName,
      funnelStep
    } = pdtData;
    this.activityName = activityName;
    this.pageName = pageName;
    this.funnelStep = funnelStep;
    this.deviceDetails = deviceDetails;
    this.userDetails = userDetails;
  }

  _getUserDetails = () => {
    if (isEmpty(this.userDetails)) {
      return user();
    }

    const userDetailsObject = {
      uuid: this.userDetails.uuid,
      email_id: this.userDetails.email,
      is_logged_in: this.userDetails.loggedIn,
      login_channel: this.userDetails.loginType,
      profile_type: this.userDetails.profileType,
      is_mobile_verified: this.userDetails.verifiedMobileNumber?.length > 0,
      mobile_country_code: '91',
      login_status: this.userDetails.loggedIn,
      is_corporate: this.userDetails.profileType === ProfileType.BUSINESS,
      marketing_cloud_id : this.userDetails.marketing_cloud_id
    };
    return user(userDetailsObject);
  };

  _getDeviceDetails = () => {
    if (isEmpty(this.deviceDetails)) {
      return null;
    }

    const deviceDetailsObject = {
      type: this.deviceDetails.deviceType,
      model: this.deviceDetails.deviceName,
      id: this.deviceDetails.deviceId,
      connection_type: this.deviceDetails.networkType,
      operating_system_version: this.deviceDetails.osVersion,
      operating_system: this.deviceDetails.os,
      application_version: this.deviceDetails.appVersion,
      flavour : this.deviceDetails.flavour
    };
    return device(deviceDetailsObject);
  };

  _getContext = () => {
    const contextObject = {
      client_timestamp: now().getTime(),
      activity_name: this.activityName,
      page_name: this.pageName,
      funnel_step: this.funnelStep
    };
    return context(contextObject);
  };

  basePdtData = () => {
    const pdtObject = railsClientNewLogging();
    pdtObject.device = this._getDeviceDetails();
    pdtObject.user = this._getUserDetails();
    pdtObject.context = this._getContext();
    return pdtObject;
  };
}
